module.exports = __webpack_public_path__ + "img/13@2x.7426aa5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/13@2x.png
// module id = DMV5
// module chunks = 0